<script setup lang="ts">
import { ArrowUp } from "lucide-vue-next";
import "@/assets/styles/footer.css";
</script>

<template>
  <footer class="footer">
    <div class="footer-main">
      <a class="footer-brand" href="#home"><span>F</span><div><strong>FREIRAUM</strong><small>Garten · Landschaft · Pflege</small></div></a>
      <p>Wir bauen Außenräume für Menschen und Unternehmen – mit Haltung, Handwerk und einem Blick fürs Ganze.</p>
      <a class="back-top" href="#home" aria-label="Nach oben"><ArrowUp /></a>
    </div>
    <div class="footer-bottom"><span>© 2026 Freiraum GaLaBau</span><div><router-link to="/impressum">Impressum</router-link><router-link to="/datenschutz">Datenschutz</router-link></div></div>
  </footer>
</template>
